var _style, _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F44336;}\n\t.st1{fill:#FFFFFF;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,254C58.5,254,2,197.5,2,128S58.5,2,128,2s126,56.5,126,126S197.5,254,128,254z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.9,187.1c-3.6,0-7.2-1.4-9.9-4.1c-5.5-5.5-5.5-14.3,0-19.8L163.2,73c5.5-5.5,14.3-5.5,19.8,0 c5.5,5.5,5.5,14.3,0,19.8L92.8,183C90.1,185.7,86.5,187.1,82.9,187.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.1,187.1c-3.6,0-7.2-1.4-9.9-4.1L73,92.8c-5.5-5.5-5.5-14.3,0-19.8c5.5-5.5,14.3-5.5,19.8,0l90.2,90.2 c5.5,5.5,5.5,14.3,0,19.8C180.3,185.7,176.7,187.1,173.1,187.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.1e7a0a04e5bcbe72db82542c68f33d46.svg";
export { ForwardRef as ReactComponent };